import React from 'react'

import {RescheduleAppointmentModalV2} from './screening/components/RescheduleAppointmentModalV2'

interface RescheduleAppointmentModalProps {
  isVisible: boolean
  onClose: () => void
  appointmentId: string
  facilityId: string
  originalDate: string
  patientName: string
  patientDob: string | null
  department: string | null
}

export const RescheduleAppointmentModal = ({
  isVisible,
  onClose,
  appointmentId,
  facilityId,
  originalDate,
  patientName,
  patientDob,
  department,
}: RescheduleAppointmentModalProps) => (
  <RescheduleAppointmentModalV2
    isVisible={isVisible}
    onClose={onClose}
    appointmentId={appointmentId}
    facilityId={facilityId}
    originalDate={originalDate}
    patientName={patientName}
    patientDob={patientDob}
    department={department}
  />
)
